module.exports = __webpack_public_path__ + "static/media/remote_engagement.45194b2d.jpg";